import React from 'react';
import { Card } from 'antd';
import { SkBar } from './_primitives';

const FaqHeader = () => (
  <>
    <div className="flex items-center gap-3 mb-2">
      <div className="w-6 h-6 rounded-full bg-gray-200 animate-pulse flex-shrink-0" />
      <SkBar h="h-7" w="w-52" className="max-w-full" />
    </div>
    <SkBar h="h-3" w="w-56" className="max-w-full mb-4" />
  </>
);

const TabsRow = () => (
  <div className="flex gap-6 border-b border-gray-200 mb-6 overflow-x-auto">
    {Array.from({ length: 2 }).map((_, i) => (
      <div
        key={i}
        className={`pb-2 flex items-center gap-2 flex-shrink-0 ${
          i === 0 ? 'border-b-2 border-gray-300' : ''
        }`}
      >
        <div className="w-4 h-4 rounded bg-gray-200 animate-pulse" />
        <SkBar h="h-4" w="w-24" />
      </div>
    ))}
  </div>
);

const FilterRow = () => (
  <div className="flex flex-col lg:flex-row gap-3 mb-6">
    <SkBar h="h-10" w="w-full lg:flex-1 lg:max-w-xs" className="rounded-md" />
    <SkBar h="h-10" w="w-full lg:w-48" className="rounded-md" />
    <SkBar h="h-10" w="w-full lg:w-40" className="rounded-md" />
    <SkBar h="h-10" w="w-full lg:w-28" className="rounded-md lg:ml-auto" />
  </div>
);

const EmptyMessage = () => (
  <div className="flex flex-col items-center justify-center gap-3 py-6 mb-4">
    <div className="w-14 h-14 rounded-lg bg-gray-100 animate-pulse" />
    <SkBar h="h-3" w="w-96" className="max-w-full" />
  </div>
);

const FAQ_COLS = ['w-16', 'w-20', 'w-16', 'w-14', 'w-16'];

const EmptyTable = () => (
  <div className="overflow-x-auto">
    <div className="min-w-[800px]">
      {/* Header row */}
      <div className="grid grid-cols-[1fr_2fr_3fr_1fr_1fr] gap-3 pb-3 border-b border-gray-200">
        {FAQ_COLS.map((w, i) => (
          <SkBar key={i} h="h-3" w={w} />
        ))}
      </div>
      {/* Empty body */}
      <div className="flex flex-col items-center justify-center gap-3 py-16">
        <div className="w-14 h-14 rounded-lg bg-gray-100 animate-pulse" />
        <SkBar h="h-3" w="w-16" />
      </div>
    </div>
  </div>
);

/**
 * FaqManagementPageLoader — matches FAQ Management layout:
 *  outer card containing icon-title + subtitle · 2 icon-tabs (FAQs/Categories) ·
 *  filter row (search · categories · status · add button) ·
 *  blocking empty-state message · empty table with "No data" placeholder.
 */
const FaqManagementPageLoader = () => (
  <div className="w-full p-3 sm:p-4 md:p-6">
    <Card className="shadow-sm" styles={{ body: { padding: 24 } }}>
      <FaqHeader />
      <TabsRow />
      <FilterRow />
      <EmptyMessage />
      <EmptyTable />
    </Card>
  </div>
);

export default FaqManagementPageLoader;
